// Whole-line kroner discount (TICKET-01868). Webapp mirror of backend/lib/line-discount.js;
// keep the two in step. Pure functions, no stores, no JSX.
//
// `discountAmount` on a sale line is, and stays, the per-unit VAT-inclusive discount
// that every total, report and accounting export multiplies by qty. With the clinic
// toggle featureFlags.discountLineAmount the sale screen lets the user type the
// discount for the whole line instead; the typed amount is kept on the line as
// `discountLineAmount` for display and `discountAmount` is derived as amount / qty.
//
// A stored discountLineAmount is only trusted while it still agrees with
// discountAmount * qty: if qty or the per-unit amount was edited elsewhere
// (toggle off, another client) the line falls back to the per-unit value.

export function isLineDiscountEnabled(customer) {
    return parseInt(customer?.featureFlags?.discountLineAmount, 10) === 1;
}

export function perUnitDiscount(lineAmount, qty) {
    const amount = Number(lineAmount) || 0;
    const count = Number(qty) || 0;
    if (count === 0) {
        return amount;
    }
    return amount / count;
}

export function lineDiscountAmount(line = {}) {
    const stored = line.discountLineAmount;
    if (typeof stored !== 'number' || !Number.isFinite(stored)) {
        return null;
    }
    const perUnit = Number(line.discountAmount) || 0;
    const qty = Number(line.qty) || 1;
    if (Math.abs(perUnit * qty - stored) > 0.005) {
        return null;
    }
    return stored;
}

export function lineDiscountForDisplay(line = {}) {
    const whole = lineDiscountAmount(line);
    if (whole !== null) {
        return whole;
    }
    return Number(line.discountAmount) || 0;
}
